import Vue from 'vue';
import {sanitizeHtml} from '~/helper/sanitize';

const setSafeHtml = (el, binding) => {
  el.innerHTML = sanitizeHtml(binding.value || '');
};

Vue.directive('safe-html', {
  inserted: setSafeHtml,
  update: setSafeHtml,
});
